import React, { useState } from 'react';

import GalleryEditor from '@components/galleryEditor/GalleryEditor';
import { useAppSelector } from '@core/hooks/appHooks';
import {
  deleteProductImage,
  listenToImageResizing,
  uploadProductImage,
} from '@core/services/networkService/functions/_storage';
import { NetworkService } from '@core/services/networkService/networkService';
import { selectVendor } from '@core/store/appSlice/appSlice';
import DemmiCard from '@demmi-ui/Card/Card';
import { demmiRequest } from '@helpers/app.helper';
import { useAuth } from '@providers/authProvider';
import { DemmiFS, Logger } from '@subhanhabib/demmilib';

import ModalAddImage from '../../../../components/modals/AddImage/ModalAddImage';

interface Props {
  product: DemmiFS.Product;
  images: DemmiFS.DemmiImageResource[];
  setImages: React.Dispatch<React.SetStateAction<DemmiFS.DemmiImageResource[]>>;
}

const Images: React.FC<Props> = ({ images, setImages, product }) => {
  const CSSBlock = 'product-images';
  const vendor = useAppSelector(selectVendor);
  const [isDoingRequest, setIsDoingRequest] = useState(false);
  const { user } = useAuth();

  const onClickDelete = (i: number) => {
    setIsDoingRequest(true);
    demmiRequest(deleteProductImage(product.docID, i)).then(res => {
      if (res === false) {
        // TODO: show error toast
      } else {
        const updatedImages = [...images.slice(0, i), ...images.slice(i + 1)];
        setImages(updatedImages);
        // TODO: show success toast
      }
      setIsDoingRequest(false);
    });
  };

  const onImageConfirm = (file: File) => {
    if (vendor && product) {
      const filename = DemmiFS.ImageHelper.Vendor.generateProductImageName(
        file,
        product.docID,
        product.vendorID,
      );
      Logger({ objs: { user, file, filename } }, onImageConfirm);

      setIsDoingRequest(true);
      demmiRequest(uploadProductImage(product.vendorID, file, filename)).then(
        imageResource => {
          if (imageResource) {
            demmiRequest(
              NetworkService.Product.updateProductImages(product.docID, [
                ...images,
                imageResource,
              ]),
            ).then(async () => {
              const unsubscribe = await listenToImageResizing(
                vendor.docID,
                filename,
                success => {
                  if (success) {
                    setImages([...images, imageResource]);
                    setIsDoingRequest(false);
                    unsubscribe();
                  } else {
                    // TODO: Show error toast
                    setImages([...images, imageResource]);
                    setIsDoingRequest(false);
                    unsubscribe();
                  }
                },
              );
            });
          } else {
            // TODO: Add toast.
            setIsDoingRequest(false);
          }
        },
      );
    }
  };

  return (
    <DemmiCard
      title="Images"
      subtitle="Max 6 images"
      className={CSSBlock}
      isLoading={isDoingRequest}
      titleButtons={[
        <ModalAddImage
          key={'modal-add'}
          disabled={images.length >= 5}
          onClose={() => {}}
          onConfirm={onImageConfirm}
        />,
      ]}>
      {images.length > 0 ? (
        <GalleryEditor
          images={images}
          setImages={setImages}
          onClickDelete={onClickDelete}
        />
      ) : (
        <div className={`${CSSBlock}__no-images`}>Nothing to show (yet..?)</div>
      )}
    </DemmiCard>
  );
};

export default Images;
